const $$splitComponentImporter = () => import('/app/apps/web/src/routes/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});